import { Supervision } from 'solar-bo';

/**
 * Fake class to share data between calls for route when need to set a complex object without the need to use a service
 */
export class SupervisLoadfilesShareData {
    public static supervision:Supervision;
} 